var Mutation, assert;

assert = require('./util').assert;

assert = require('./util').assert;

module.exports = Mutation = (function() {

  /*
  Section: Constants
   */
  Mutation.ATTRIBUTE_CHANGED = 'attribute';

  Mutation.BODY_CHANGED = 'body';

  Mutation.CHILDREN_CHANGED = 'children';


  /*
  Section: Attribute
   */

  Mutation.prototype.target = null;

  Mutation.prototype.type = null;

  Mutation.prototype.attributeName = null;

  Mutation.prototype.attributeOldValue = null;

  Mutation.prototype.insertedTextLocation = null;

  Mutation.prototype.insertedTextLength = null;

  Mutation.prototype.replacedText = null;

  Mutation.prototype.addedItems = null;

  Mutation.prototype.removedItems = null;

  Mutation.prototype.previousSibling = null;

  Mutation.prototype.nextSibling = null;

  Mutation.createAttributeMutation = function(target, attributeName, attributeOldValue) {
    var mutation;
    assert(attributeName, 'Expect valid attribute name');
    mutation = new Mutation(target, Mutation.ATTRIBUTE_CHANGED);
    mutation.attributeName = attributeName;
    mutation.attributeOldValue = attributeOldValue;
    return mutation;
  };

  Mutation.createBodyMutation = function(target, insertedTextLocation, insertedTextLength, replacedText) {
    var mutation;
    assert(insertedTextLocation != null, 'Expect valid insertedTextLocation');
    assert(insertedTextLength != null, 'Expect valid insertedTextLength');
    mutation = new Mutation(target, Mutation.BODY_CHANGED);
    mutation.insertedTextLocation = insertedTextLocation;
    mutation.insertedTextLength = insertedTextLength;
    mutation.replacedText = replacedText;
    return mutation;
  };

  Mutation.createChildrenMutation = function(target, addedItems, removedItems, previousSibling, nextSibling) {
    var mutation;
    assert(addedItems.length > 0 || removedItems.length > 0, 'Children added or removed');
    mutation = new Mutation(target, Mutation.CHILDREN_CHANGED);
    mutation.addedItems = (addedItems != null ? addedItems.slice() : void 0) || [];
    mutation.removedItems = (removedItems != null ? removedItems.slice() : void 0) || [];
    mutation.previousSibling = previousSibling;
    mutation.nextSibling = nextSibling;
    return mutation;
  };

  function Mutation(target1, type) {
    this.target = target1;
    this.type = type;
    this.flattendedAddedItems = null;
    this.flattenedRemovedItems = null;
  }

  Mutation.prototype.copy = function() {
    var mutation, ref;
    mutation = new Mutation(this.target, this.type);
    mutation.attributeName = this.attributeName;
    mutation.attributeNewValue = this.attributeNewValue;
    mutation.attributeOldValue = this.attributeOldValue;
    mutation.insertedTextLocation = this.insertedTextLocation;
    mutation.insertedTextLength = this.insertedTextLength;
    mutation.replacedText = (ref = this.replacedText) != null ? ref.copy() : void 0;
    mutation.addedItems = this.addedItems;
    mutation.removedItems = this.removedItems;
    mutation.previousSibling = this.previousSibling;
    mutation.nextSibling = this.nextSibling;
    return mutation;
  };

  Mutation.prototype.getFlattendedAddedItems = function() {
    var each, eachDescendant, i, j, len, len1, ref, ref1;
    if (!this.flattendedAddedItems) {
      this.flattendedAddedItems = [];
      ref = this.addedItems;
      for (i = 0, len = ref.length; i < len; i++) {
        each = ref[i];
        this.flattendedAddedItems.push(each);
        if (each.hasChildren) {
          ref1 = each.descendants;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            eachDescendant = ref1[j];
            this.flattendedAddedItems.push(eachDescendant);
          }
        }
      }
    }
    return this.flattendedAddedItems;
  };

  Mutation.prototype.getFlattendedAddedItemIDs = function() {
    var each, i, len, ref, results;
    ref = this.getFlattendedAddedItems();
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      each = ref[i];
      results.push(each.id);
    }
    return results;
  };

  Mutation.prototype.getFlattendedRemovedItems = function() {
    var each, eachDescendant, i, j, len, len1, ref, ref1;
    if (!this.flattenedRemovedItems) {
      this.flattenedRemovedItems = [];
      ref = this.removedItems;
      for (i = 0, len = ref.length; i < len; i++) {
        each = ref[i];
        this.flattenedRemovedItems.push(each);
        if (each.hasChildren) {
          ref1 = each.descendants;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            eachDescendant = ref1[j];
            this.flattenedRemovedItems.push(eachDescendant);
          }
        }
      }
    }
    return this.flattenedRemovedItems;
  };

  Mutation.prototype.getFlattendedRemovedItemIDs = function() {
    var each, i, len, ref, results;
    ref = this.getFlattendedRemovedItems();
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      each = ref[i];
      results.push(each.id);
    }
    return results;
  };

  Mutation.prototype.performUndoOperation = function() {
    switch (this.type) {
      case Mutation.ATTRIBUTE_CHANGED:
        return this.target.setAttribute(this.attributeName, this.attributeOldValue);
      case Mutation.BODY_CHANGED:
        return this.target.replaceBodyRange(this.insertedTextLocation, this.insertedTextLength, this.replacedText);
      case Mutation.CHILDREN_CHANGED:
        if (this.addedItems.length) {
          this.target.removeChildren(this.addedItems);
        }
        if (this.removedItems.length) {
          return this.target.insertChildrenBefore(this.removedItems, this.nextSibling, true);
        }
    }
  };

  Mutation.prototype.coalesce = function(operation) {
    var newInsertedTextLength, newInsertedTextLocation, newReplaceEnd, newReplaceLength, singleDeleteFromEnd, singleInsertAtEnd, thisInsertEnd, thisInsertLength, thisInsertedTextLocation;
    if (!(operation instanceof Mutation)) {
      return false;
    }
    if (this.target !== operation.target) {
      return false;
    }
    if (this.type !== operation.type) {
      return false;
    }
    if (this.type !== Mutation.BODY_CHANGED) {
      return false;
    }
    thisInsertedTextLocation = this.insertedTextLocation;
    thisInsertLength = this.insertedTextLength;
    thisInsertEnd = thisInsertedTextLocation + thisInsertLength;
    thisInsertEnd = thisInsertedTextLocation + thisInsertLength;
    newInsertedTextLocation = operation.insertedTextLocation;
    newInsertedTextLength = operation.insertedTextLength;
    newReplaceLength = operation.replacedText.length;
    newReplaceEnd = newInsertedTextLocation + newReplaceLength;
    singleInsertAtEnd = newInsertedTextLocation === thisInsertEnd && newInsertedTextLength === 1 && newReplaceLength === 0;
    singleDeleteFromEnd = newReplaceEnd === thisInsertEnd && newInsertedTextLength === 0 && newReplaceLength === 1;
    if (singleInsertAtEnd) {
      this.insertedTextLength++;
      return true;
    } else if (singleDeleteFromEnd) {
      if (newInsertedTextLocation < thisInsertedTextLocation) {
        this.replacedText.insertText(0, operation.replacedText);
        this.insertedTextLocation--;
      } else {
        this.insertedTextLength--;
      }
      return true;
    } else {
      return false;
    }
  };

  return Mutation;

})();



/*****************
 ** WEBPACK FOOTER
 ** ./lib/mutation.js
 ** module id = 192
 ** module chunks = 0
 **/